module.exports = __webpack_public_path__ + "img/login-bg.cc54d016.png";